import { useEffect } from "react";
import { useLiveResource } from "@/hooks/useLiveResource";

const setMeta = (name, content, attr = "name") => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Applies SEO tags + injects admin custom CSS/JS into the public site (auto-syncs).
export const CustomInject = () => {
  const { data: seo } = useLiveResource("/public/seo");
  const { data: code } = useLiveResource("/public/code");

  useEffect(() => {
    if (!seo) return;
    if (seo.title) document.title = seo.title;
    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords);
    setMeta("robots", seo.robots);
    setMeta("og:title", seo.title, "property");
    setMeta("og:description", seo.description, "property");
    if (seo.og_image) setMeta("og:image", seo.og_image, "property");
    if (seo.google_verification) setMeta("google-site-verification", seo.google_verification);
    if (seo.canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = seo.canonical;
    }
  }, [seo]);

  useEffect(() => {
    if (!code) return;
    if (code.css != null) {
      let style = document.getElementById("mg-custom-css");
      if (!style) { style = document.createElement("style"); style.id = "mg-custom-css"; document.head.appendChild(style); }
      style.textContent = code.css || "";
    }
    if (code.js != null) {
      const old = document.getElementById("mg-custom-js");
      if (old) old.remove();
      if (code.js) {
        const script = document.createElement("script");
        script.id = "mg-custom-js";
        script.textContent = `try{${code.js}}catch(e){console.warn('custom js error',e)}`;
        document.body.appendChild(script);
      }
    }
    if (code.html != null) {
      let holder = document.getElementById("mg-custom-html");
      if (!holder) { holder = document.createElement("div"); holder.id = "mg-custom-html"; document.body.appendChild(holder); }
      holder.innerHTML = code.html || "";
    }
  }, [code]);

  return null;
};
